import { FunctionComponent } from 'react';
import { Routes, Route } from 'react-router-dom';
import BasicFinancialQuiz from 'src/pages/website/Education/BasicFinancialQuiz';
import MilitaryLandingPage from 'src/pages/website/Education/MilitaryLandingPage';

const EducationRoutes: FunctionComponent = () => (
  <Routes>
    <Route path='/basic-fin-quiz-01' element={<BasicFinancialQuiz />} />
    <Route path='/military' element={<MilitaryLandingPage />} />
  </Routes>
);

export default EducationRoutes;

